import { Card, CardContent, Checkbox, Typography } from '@material-ui/core';
import CustomCardHeading from 'components/CustomCardHeading/CustomCardHeading.jsx';
import React from 'react';

class CompanySelection extends React.Component {
	state = {
		availTargets: []
	};

	componentDidMount() {
		this.props.scrollMeBar();
	}

	handleCheck = id => {
		if (this.props.selectedTargets.find(t => t === id)) {
			this.props.checkSelectedTarget(id, false);
		} else {
			this.props.checkSelectedTarget(id, true);
		}
		this.forceUpdate();
	};

	checkAll = () => {
		if (
			this.props.selectedTargets.length !==
			this.props.AvailTargetsForBroker.length
		) {
			this.props.toggleAllTargets(this.props.AvailTargetsForBroker, true);
		} else {
			this.props.toggleAllTargets(this.props.AvailTargetsForBroker, false);
		}
		this.forceUpdate();
	};

	render() {
		let targets = this.props.AvailTargetsForBroker;
		const allSelected = this.props.selectedTargets.length === targets.length;

		return (
			<div className="contentWithStepper">
				<Card className={this.classes}>
					<CardContent>
						<CustomCardHeading
							subheading="Quote Generation"
							caption={this.props.clientFullname}
							headline="Company Selection"
						/>
						{targets.length > 0 ? (
							<div
								style={{
									display: 'block',
									width: '100%',
									marginTop: '15px'
								}}
							>
								<div style={{ display: 'flex' }}>
									<Checkbox checked={allSelected} onChange={this.checkAll} />
									<p
										className={'checkBoxText'}
										style={{ fontSize: '15px', color: '#6f6d6d' }}
									>
										Select All
									</p>
								</div>
								<div style={{ width: '100%' }}>
									{targets.map(target => {
										const imgSrc = `/assets/logo/${target.logo}`;
										const selected = this.props.selectedTargets.find(
											s => s === target.id
										)
											? true
											: false;

										return (
											<div
												key={target.id}
												className={'checkboxContainer'}
												style={selected ? { backgroundColor: '#f5f5f5' } : {}}
												onClick={() => this.handleCheck(target.id)}
											>
												<Checkbox checked={selected} />
												<img
													src={imgSrc}
													alt={target.name}
													className="targetAffiliationLogo"
													style={{ marginLeft: '20px' }}
												/>
											</div>
										);
									})}
								</div>
							</div>
						) : (
							<Typography style={{ marginTop: '25px' }}>
								You currently have no active FSP details.
							</Typography>
						)}

						<div style={{ marginTop: '25px' }}>
							<Typography>
								You can set your FSP login details{' '}
								<span
									className="typographyLink"
									onClick={() =>
										this.props.history.push({
											pathname: '/app/companylogindetails'
										})
									}
								>
									HERE
								</span>
							</Typography>
						</div>
					</CardContent>
				</Card>
			</div>
		);
	}
}

export default CompanySelection;



// WEBPACK FOOTER //
// ./src/views/Quote/QuoteWizard/steps/CompanySelection.jsx